import React, { useEffect, useState } from "react";
import { CloseIcon, Dialog, Dropdown, Input } from "@fluentui/react-northstar";
import { useTranslation } from "react-i18next";
import "../index.scss";
import axios from "axios";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { TextField } from "@mui/material";
import { toast } from "react-toastify";

const UploadSingleParentModel = (props) => {
  const [parentDetails, setParentDetails] = useState({
    name: "",
    email: "",
    provider: "",
    number: NaN,
    expirationDate: "",
  });
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isValidEmail, setIsValidEmail] = useState(true);

  const providers = ["Microsoft", "Google"];

  const { t } = useTranslation();

  const parentDialog = t("setting").parent.parentDialog;

  const selectedProvider = providers.find(
    (provider) =>
      provider.toLowerCase() === parentDetails.provider.toLowerCase()
  );

  const detectProvider = async (email = "") => {
    if (!email.trim()) return false;

    if (!email.includes("@")) {
      setIsValidEmail(false);
      return false;
    }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_EP_URL}/api/user/check-email-provider?email=${email}`
      );

      const data = response?.data;

      if (data?.provider === "Microsoft") {
        setParentDetails({ ...parentDetails, provider: "Microsoft" });
        setIsValidEmail(true);
        return true;
      } else if (data?.provider === "Google") {
        setParentDetails({ ...parentDetails, provider: "Google" });
        setIsValidEmail(true);
        return true;
      } else {
        setIsValidEmail(false);
        return false;
      }
    } catch (error) {
      console.log("error", error);
      setIsValidEmail(false);
      return false;
    }
  };

  // useEffect to call detectProvider when email changes
  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      if (parentDetails.email) {
        detectProvider(parentDetails.email);
      }
    }, 500); // Debounce of 500ms to prevent API calls on every keystroke

    return () => clearTimeout(debounceTimeout);
  }, [parentDetails.email]);

  const handleReset = () => {
    setParentDetails({
      name: "",
      email: "",
      provider: "",
      number: NaN,
      expirationDate: "",
    });
    setSelectedStudents([]);
    setShowError(false);
    setIsValidEmail(true);
  };

  const handleAddParent = async () => {
    if (
      !!parentDetails.name.trim() &&
      !!parentDetails.email.trim() &&
      !!parentDetails.provider.trim() &&
      !!parentDetails.number.trim() &&
      !!parentDetails.expirationDate &&
      selectedStudents.length
    ) {
      setIsLoading(true);
      const isValidEmail = await detectProvider(parentDetails.email);
      if (!isValidEmail) {
        setIsLoading(false);
        return;
      }
      const payload = {
        parentData: {
          parentName: parentDetails.name,
          parentEmail: parentDetails.email,
          number: parentDetails.number,
          expirationDate: parentDetails.expirationDate,
          provider: parentDetails.provider,
        },
        students: selectedStudents.map((student) => student.key),
      };
      try {
        let config = {
          method: "post",
          url: `${process.env.REACT_APP_EP_URL}/api/parents${props.user.slug}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + props.user.accessToken,
          },
          data: payload,
        };

        const response = await axios.request(config);
        setIsLoading(false);
        if (response.data.success) {
          props.getAllParents();
          handleReset();
          props.onClose();
        } else {
          const failedParent = response.data;
          const errorMessage =
            failedParent.isExist && failedParent.role
              ? `This user already exists with a ${failedParent.role} role in your school.`
              : "Parent Adding Failed!";
          toast.error(errorMessage);
        }
      } catch (error) {
        setIsLoading(false);
        console.log(error);
        toast.error("Parent Adding Failed!");
      }
    } else {
      setShowError(true);
    }
  };

  return (
    <Dialog
      open={props.isOpen}
      content={
        <div className="upload-single-parent-model-content">
          <div style={{ width: "100%" }}>
            <p className="sub-title">{parentDialog.parentName.title}</p>
            <Input
              placeholder={parentDialog.parentName.placeholder}
              name="parentName"
              className="parent-input"
              value={parentDetails.name}
              onChange={(e) => {
                setParentDetails({ ...parentDetails, name: e.target.value });
              }}
              status={
                showError ? (!parentDetails.name?.length ? "error" : "") : ""
              }
              style={{ width: "100%" }}

              // disabled={isLoading}
            />
            {showError ? (
              !parentDetails.name?.length ? (
                <p style={{ color: "red", fontSize: "13px" }}>
                  {parentDialog.parentName.validationMsg}
                </p>
              ) : (
                ""
              )
            ) : (
              ""
            )}
          </div>
          <div style={{ width: "100%" }}>
            <p className="sub-title">{parentDialog.parentEmail.title}</p>
            <Input
              placeholder={parentDialog.parentEmail.placeholder}
              name="parentEmail"
              className="parent-input"
              value={parentDetails.email}
              onChange={(e) => {
                setParentDetails({ ...parentDetails, email: e.target.value });
              }}
              status={
                showError ? (!parentDetails.email?.length ? "error" : "") : ""
              }
              // disabled={isLoading}
              style={{ width: "100%" }}
            />

            {!isValidEmail && (
              <p style={{ color: "red", fontSize: "13px", marginBottom: 0 }}>
                {parentDialog.parentEmail.enterValidEmail}
              </p>
            )}

            {showError ? (
              !parentDetails.email?.length ? (
                <p style={{ color: "red", fontSize: "13px", marginBottom: 0 }}>
                  {parentDialog.parentEmail.validationMsg}
                </p>
              ) : (
                ""
              )
            ) : (
              ""
            )}
            <p style={{ color: "orange", fontSize: "13px", paddingTop: "5px" }}>
              {parentDialog.parentEmail.warningMsg}
            </p>
          </div>
          <div style={{ width: "100%" }}>
            <p className="sub-title">{parentDialog.parentNumber.title}</p>
            <Input
              placeholder={parentDialog.parentNumber.placeholder}
              name="parentNumber"
              type="number"
              className="parent-input"
              value={parentDetails.number}
              onChange={(e) => {
                setParentDetails({ ...parentDetails, number: e.target.value });
              }}
              status={
                showError ? (!parentDetails.number?.length ? "error" : "") : ""
              }
              // disabled={isLoading}
              style={{ width: "100%" }}
            />
            {showError ? (
              !parentDetails.number?.length ? (
                <p style={{ color: "red", fontSize: "13px" }}>
                  {parentDialog.parentNumber.validationMsg}
                </p>
              ) : (
                ""
              )
            ) : (
              ""
            )}
          </div>
          <div style={{ width: "100%" }}>
            <p className="sub-title">{parentDialog.expiryDate.title}</p>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={
                  parentDetails.expirationDate
                    ? moment(parentDetails.expirationDate)
                    : null
                }
                disablePast
                disabled={isLoading}
                onChange={(v) => {
                  const date = moment.utc(moment(v.$d).format("YYYY-MM-DD"));
                  setParentDetails({ ...parentDetails, expirationDate: date });
                }}
                PopperProps={{
                  // disablePortal: true,
                  sx: { zIndex: 16000 },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="outlined"
                    value={
                      parentDetails?.expirationDate
                        ? moment(parentDetails.expirationDate).format(
                            "YYYY-MM-DD"
                          )
                        : null
                    }
                    disabled={isLoading}
                    contentEditable={false}
                    // inputProps={{ style: { fontSize: 13 } }}
                    error={showError && !parentDetails.expirationDate}
                  />
                )}
              />
            </LocalizationProvider>
            {showError ? (
              !parentDetails.expirationDate ? (
                <p style={{ color: "red", fontSize: "13px" }}>
                  {parentDialog.expiryDate.validationMsg}
                </p>
              ) : (
                ""
              )
            ) : (
              ""
            )}
          </div>
          <div>
            <p className="sub-title">{parentDialog.students.title}</p>

            {props.studentsWithoutParents.length > 0 && (
              <Dropdown
                disabled={false}
                search
                multiple
                fluid
                items={props.studentsWithoutParents}
                placeholder={parentDialog.students.placeholder}
                value={selectedStudents}
                defaultValue={selectedStudents}
                getA11ySelectionMessage={{
                  onAdd: (item) => {
                    let clonedSelectedStudents = [...selectedStudents];
                    clonedSelectedStudents.push(item);
                    setSelectedStudents(clonedSelectedStudents);
                    let clonedStudentsWithoutParents =
                      props.studentsWithoutParents.filter(
                        (s) => s?.key && s.key !== item.key
                      );
                    props.setStudentsWithoutParents(
                      clonedStudentsWithoutParents
                    );
                  },
                  onRemove: (item) => {
                    const updatedlist = selectedStudents.filter(
                      (s) => s?.key && s.key !== item.key
                    );
                    let clonedStudentsWithoutParents = [
                      item,
                      ...props.studentsWithoutParents,
                    ];
                    clonedStudentsWithoutParents.push(item);
                    props.setStudentsWithoutParents(
                      clonedStudentsWithoutParents
                    );
                    setSelectedStudents(updatedlist);
                  },
                }}
                noResultsMessage={"No results"}
                className="select-students-dropdown"
              />
            )}
            {showError ? (
              selectedStudents.length === 0 ? (
                <p style={{ color: "red", fontSize: "13px" }}>
                  {parentDialog.students.validationMsg}
                </p>
              ) : (
                ""
              )
            ) : (
              ""
            )}
          </div>
          <div>
            <p className="sub-title">{parentDialog.provider.title}</p>

            {providers.length > 0 && (
              <Dropdown
                disabled={false}
                // multiple
                fluid
                items={providers}
                placeholder={parentDialog.provider.placeholder}
                value={selectedProvider}
                onChange={(e, { value }) => {
                  setParentDetails({
                    ...parentDetails,
                    provider: value.toLowerCase(),
                  });
                }}
                noResultsMessage={"No results"}
                className="select-provider-dropdown"
              />
            )}
            {showError ? (
              !parentDetails.provider.trim() ? (
                <p style={{ color: "red", fontSize: "13px" }}>
                  {parentDialog.provider.validationMsg}
                </p>
              ) : (
                ""
              )
            ) : (
              ""
            )}
          </div>
        </div>
      }
      header={parentDialog.addParentTitle}
      className="smallDlg"
      confirmButton={
        isLoading
          ? {
              text: parentDialog.addButton,
              disabled: true,
              loading: true,
            }
          : parentDialog.addButton
      }
      cancelButton={
        isLoading
          ? { text: parentDialog.cancelButton, disabled: true }
          : parentDialog.cancelButton
      }
      onConfirm={handleAddParent}
      onCancel={() => {
        props.onClose();
        handleReset();
      }}
      headerAction={{
        icon: <CloseIcon />,
        title: "Close",
        onClick: () => {
          props.onClose();
          handleReset();
        },
        disabled: isLoading,
      }}
    />
  );
};

export default UploadSingleParentModel;
